export enum ELocalesLanguages {
  en = 'enUS',
  ua = 'ukUA',
  ru = 'ruRU',
  ro = 'roRO',
}
